import { render } from "./yeji-form.vue?vue&type=template&id=4d3ceef8&scoped=true"
import script from "./yeji-form.vue?vue&type=script&lang=js"
export * from "./yeji-form.vue?vue&type=script&lang=js"

import "./yeji-form.vue?vue&type=style&index=0&id=4d3ceef8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3ceef8"]])

export default __exports__